import Head from "next/head";
import PageBanner from "@/components/ui/PageBanner";
import LoginForm from "@/components/auth/LoginForm";
import DownloadApp from "@/components/shared/DownloadApp";

export default function LoginPage() {
    return (
        <>
            <Head>
                <title>Login | Access Your CarSparesEzyFind Account | Car Parts South Africa</title>
                <meta name="description" content="Log in to your CarSparesEzyFind account to manage orders, track car part deliveries, save favourite parts, and access exclusive deals from verified auto parts suppliers across South Africa." />
                <meta name="keywords" content="CarSparesEzyFind login, car parts account login, auto parts South Africa sign in, car spares account" />
                <meta name="robots" content="noindex, follow" />
                <meta property="og:title" content="Login | CarSparesEzyFind" />
                <meta property="og:description" content="Log in to your CarSparesEzyFind account to manage orders, track deliveries and access exclusive car parts deals across South Africa." />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="CarSparesEzyFind" />
            </Head>
            <PageBanner backgroundImage='/images/register_banner.webp' title='Log in' />
            <div className='w-[95%] md:w-2xl mx-auto my-25'>
                <LoginForm />
            </div>
            <DownloadApp />

        </>
    )
}